/*
  Versandzeile im Kaching-Warenkorb.

  Fuegt unter der Zwischensumme eine Zeile "Versand" ein. Die Schwelle fuer
  den Gratisversand wird live aus der Kaching-App gelesen
  (window.__kachingCartProps), pro Markt. Die Versandpreise selbst stellt die
  App nicht bereit und stehen deshalb unten als Konstante.

  Das Styling liegt im Custom-CSS-Feld der Kaching-App (.ts-shipping-row).
*/

(function () {
  // ===== Einzige Stelle zum Pflegen =====
  var SHIPPING = {
    DE: { cost: 4.99, cur: '\u20AC' },
    AT: { cost: 7.99, cur: '\u20AC' },
    CH: { cost: 9.99, cur: 'CHF' }
  };
  var LABEL = 'Versand';
  var FREE = 'Kostenlos';
  // ======================================

  var pending = false;
  var OPTS = { childList: true, subtree: true, characterData: true };

  // Schwelle fuer Gratisversand aus der App, passend zum aktiven Markt.
  function threshold() {
    try {
      var p = window.__kachingCartProps;
      var t = p.cartSettings.tieredPromotionsBar;
      var mid = 'gid://shopify/Market/' + p.market.id;
      var m = (t.marketSpecificTiers || []).filter(function (x) {
        return x.marketId === mid;
      })[0];
      var tiers = (m && m.tiers) || t.tiers || [];
      var s = tiers.filter(function (x) {
        return x.type === 'shipping-discount';
      });
      return s.length ? s[0].threshold : null;
    } catch (e) {
      return null;
    }
  }

  // Zwischensumme aus dem DOM lesen, damit die Zeile immer synchron ist.
  function subtotal() {
    var el = document.querySelector('.kaching-cart__subtotal span');
    if (!el) return null;
    var n = el.textContent
      .replace(/[^0-9.,]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');
    var v = parseFloat(n);
    return isNaN(v) ? null : v;
  }

  function fmt(v, c) {
    return v.toFixed(2).replace('.', ',') + ' ' + c;
  }

  function apply() {
    var sub = document.querySelector('.kaching-cart__subtotal');
    if (!sub) return;
    var st = subtotal();
    if (st === null) return;

    var cc = (window.Shopify && window.Shopify.country) || 'DE';
    var cfg = SHIPPING[cc] || SHIPPING.DE;
    var th = threshold();
    var free = th !== null && st >= th;

    var row = document.querySelector('.ts-shipping-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'ts-shipping-row';
      var a = document.createElement('span');
      a.className = 'ts-shipping-label';
      var b = document.createElement('span');
      b.className = 'ts-shipping-value';
      row.appendChild(a);
      row.appendChild(b);
    }

    // Kaching rendert den Footer neu, deshalb jedes Mal pruefen.
    if (!row.isConnected || row.previousElementSibling !== sub) {
      sub.insertAdjacentElement('afterend', row);
    }

    var l = row.firstChild;
    var v = row.lastChild;
    var txt = free ? FREE : fmt(cfg.cost, cfg.cur);

    // Nur schreiben, wenn sich etwas geaendert hat: sonst loest der eigene
    // Schreibvorgang den Observer wieder aus (Endlosschleife).
    if (l.textContent !== LABEL) l.textContent = LABEL;
    if (v.textContent !== txt) v.textContent = txt;
    if (v.classList.contains('is-free') !== free) v.classList.toggle('is-free', free);
  }

  // Observer waehrend des eigenen Schreibens abkoppeln, danach wieder anhaengen.
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      obs.disconnect();
      try {
        apply();
      } catch (e) {}
      obs.observe(document.body, OPTS);
    }, 50);
  }

  var obs = new MutationObserver(schedule);
  obs.observe(document.body, OPTS);
  schedule();
})();
